import firebase from '~/plugins/firebase.js';
global['firebase'] = firebase

import '~/styles/main.less';

import marked from 'marked';
global['marked'] = marked

import moment from 'moment';
global['moment'] = moment

import axios from 'axios';
global['axios'] = axios

import app from '~/scripts/app.js';
global['app'] = app
